export const NotificationType: { value: string; text: string }[] = [
  { value: 'ConfirmVisit', text: 'Подтверждение визита' },
  { value: 'CancelVisit', text: 'Отмена визита' },
  { value: 'VisitRegister', text: 'Запись на приём' },
];
